// extracted by mini-css-extract-plugin
export var button = "_eq-4";
export var hasDarkBackground = "_eq-7";
export var hasLightBackground = "_eq-6";
export var iconWrapper = "_eq-0";
export var large = "_eq-2";
export var medium = "_eq-1";
export var small = "_eq-5";
export var xsmall = "_eq-3";